export function generateDateRangeSet(start: string, end: string): Set<string> {
    const startD = new Date(start);
    const endD = new Date(end);

    const s = startD < endD ? startD : endD;
    const e = startD > endD ? startD : endD;

    const rangeSet = new Set<string>();
    const cur = new Date(s);

    while (cur <= e) {
        const yyyy = cur.getFullYear();
        const mm = String(cur.getMonth() + 1).padStart(2, '0');
        const dd = String(cur.getDate()).padStart(2, '0');
        rangeSet.add(`${yyyy}-${mm}-${dd}`);
        cur.setDate(cur.getDate() + 1);
    }

    return rangeSet;
}
